import * as HmiFiles from '../hmifiles';
import { SetParamGlobal } from '../hmiclientsdata';
import * as hmiclientbase from '../hmiclientbase';
import { pinnedLeftMenu } from 'components/MainPage/dcs/centumvp/LeftMenu';
import Test from '../../MainPage/dcs/centumvp/components/Tabs/MainWindowTab';

let inputNameValue: string = '';
let lastMenu: string = '';

export let NameLeft: string = '';
//Хранение всех параметров в открытой мнемосхеме, для алармов
export interface MnemoAlrmStructure {
    [key: string]: {
        Alarms: any[];
        Top: any[];
    };
}

export const MnemoParams: MnemoAlrmStructure = {};

export const CentumVP = {
    open_leftmenu: (name: string) => {
        let centumvp_open_leftmenu: HTMLElement = (
            document.getElementsByClassName('centumvp_open_leftmenu') as HTMLCollectionOf<HTMLElement>
        )[0];
        centumvp_open_leftmenu.style.opacity = '0';

        // (document.getElementsByClassName("centumvp_left_panel_main") as HTMLCollectionOf<HTMLElement>)[0].innerHTML = "";

        if (lastMenu != '' && name === 'OpenMenu') {
            name = lastMenu;
        }

        switch (name) {
            case 'OpenMenu':
                (
                    document.getElementsByClassName('centumvp_left_menu') as HTMLCollectionOf<HTMLElement>
                )[0].style.visibility = 'visible';
                lastMenu = name;
                break;
            case 'Overview':
                CentumVP.cleaner_left_menu();
                document.getElementById('g4318')?.classList.add('activ');
                (
                    document.getElementsByClassName('centumvp_left_menu') as HTMLCollectionOf<HTMLElement>
                )[0].style.visibility = 'visible';
                // CentumVP.render_view_over();
                CentumVP.render_view('Overview');
                lastMenu = name;
                break;
            case 'PresetMenu':
                CentumVP.cleaner_left_menu();
                document.getElementById('g4361')?.classList.add('activ');
                (
                    document.getElementsByClassName('centumvp_left_menu') as HTMLCollectionOf<HTMLElement>
                )[0].style.visibility = 'visible';
                // CentumVP.render_view_pmenu();
                CentumVP.render_view('Preset Menu');
                lastMenu = name;
                break;
            case 'NameInput':
                CentumVP.cleaner_left_menu();
                document.getElementById('g4375')?.classList.add('activ');
                (
                    document.getElementsByClassName('centumvp_left_menu') as HTMLCollectionOf<HTMLElement>
                )[0].style.visibility = 'visible';
                // CentumVP.render_view_input();
                CentumVP.render_view('Name Input');
                lastMenu = name;
                break;
            case 'ToolButton':
                CentumVP.cleaner_left_menu();
                document.getElementById('g4368')?.classList.add('activ');
                (
                    document.getElementsByClassName('centumvp_left_menu') as HTMLCollectionOf<HTMLElement>
                )[0].style.visibility = 'visible';
                // CentumVP.render_view_tool();
                CentumVP.render_view('Tool Button');
                lastMenu = name;
                break;
            default:
                console.log('ButtonName:' + name);
                break;
        }
    },
    cleaner_left_menu: () => {
        var tempObj = document.getElementById('g4318') as HTMLElement;
        if (tempObj.classList.contains('activ')) tempObj.classList.remove('activ');
        tempObj = document.getElementById('g4361') as HTMLElement;
        if (tempObj.classList.contains('activ')) tempObj.classList.remove('activ');
        tempObj = document.getElementById('g4368') as HTMLElement;
        if (tempObj.classList.contains('activ')) tempObj.classList.remove('activ');
        tempObj = document.getElementById('g4375') as HTMLElement;
        if (tempObj.classList.contains('activ')) tempObj.classList.remove('activ');
    },
    close_left_menu: () => {
        (document.getElementsByClassName('centumvp_left_menu') as HTMLCollectionOf<HTMLElement>)[0].style.visibility =
            'hidden';

        let centumvp_open_leftmenu: HTMLElement = (
            document.getElementsByClassName('centumvp_open_leftmenu') as HTMLCollectionOf<HTMLElement>
        )[0];
        centumvp_open_leftmenu.style.opacity = '1';

        (document.getElementsByClassName('centumvp-window') as HTMLCollectionOf<HTMLElement>)[0].style.paddingLeft =
            '40px';
    },
    render_view: (name: string) => {
        const eventName = 'RenderLeftMenu';
        const overviewEvent = new CustomEvent(eventName, { detail: { name } });
        document.dispatchEvent(overviewEvent);
    },
    render_view_pmenu: () => {
        // let view_inp = "";
        // view_inp = '<div class="centumvp_left_panel_main_name">' +
        //     '<h3 style="color:#ffffff;margin: 3px;">Preset Menu</h3>' +
        //     '</div>'
        //    ;
        // (document.getElementsByClassName("centumvp_left_panel_main") as HTMLCollectionOf<HTMLElement>)[0].innerHTML = view_inp;
    },
    render_view_over: () => {
        // let view_inp;
        // view_inp = '<div class="centumvp_left_panel_main_name">' +
        //                 '<h3 style="color:#ffffff;margin: 3px;">Overview</h3>' +
        //             '</div>';
        // (document.getElementsByClassName("centumvp_left_panel_main") as HTMLCollectionOf<HTMLElement>)[0].innerHTML = view_inp;
    },
    render_view_input: () => {
        // let view_inp = "";
        // const menuAction = pinnedLeftMenu ? '' : 'CentumVP.close_left_menu();';
        // view_inp = '<div class="centumvp_left_panel_main_name">' +
        //     '<h3 style="color:#ffffff;margin: 3px;">Name Input</h3>' +
        //     '</div>' +
        //     '<p class="centumvp_left_panel_main_inputs">Window Name Input<br>' +
        //     '<input type="text" size="30" id="TextNameInput" value="' + inputNameValue + '" oninput="CentumVP.save_input_value(this.value);" onkeyup="if(event.keyCode === 13) CentumVP.set_name_input();"><input type="submit" value="CALL" onclick="CentumVP.set_name_input(this.value); '+ menuAction +'"></p>' +
        //     '<p><input type="checkbox" name="option1" value="a1">Default Station Information</p>';
        // (document.getElementsByClassName("centumvp_left_panel_main") as HTMLCollectionOf<HTMLElement>)[0].innerHTML = view_inp;
    },
    set_name_input: () => {
        let name = (document.getElementById('TextNameInput') as any).value;

        window.SearchRun(name);
    },
    save_input_value: (value: string) => {
        inputNameValue = value;
    },
    render_view_tool: () => {
        // fetch(
        //     '/ixyber/vision/dcs/centumvp/centumvp_left_tool.html',
        // ).then(response => response.text())
        //     .then(svg => {
        //         (document.getElementsByClassName("centumvp_left_panel_main") as HTMLCollectionOf<HTMLElement>)[0].innerHTML = svg;
        //     });
    },
    click_arrow_panel: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => {
        const obj = event.currentTarget;
        const Open = obj.getAttribute('panel-open');
        const name = obj.getAttribute('name-group');

        let TempName = name + '_Button';

        if (name != null) {
            if (Open) {
                obj.setAttribute('panel-open', '');
                (document.getElementById(name) as HTMLElement).style.height = Open;
                (document.getElementById(TempName) as HTMLElement).style.display = 'block';
                obj.innerHTML =
                    '<path fill="none" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="4" d="m2.61161,6.06018l3.02566,-2.989l3.02599,3.03886" id="path7302" />';
            } else {
                obj.setAttribute('panel-open', (document.getElementById(name) as HTMLElement)?.style.height);
                (document.getElementById(name) as HTMLElement).style.height = '20px';
                (document.getElementById(TempName) as HTMLElement).style.display = 'none';
                obj.innerHTML =
                    '<path transform= "rotate(-180 5.637434959411621,4.590610027313232) " id= "path7302" d= "m2.61161,6.06018l3.02566,-2.989l3.02599,3.03886" stroke- miterlimit="4" stroke- linejoin="round" stroke- linecap="round" stroke- width="1.5" stroke= "#000000" fill= "none" />';
            }
        }
    },
    click__tool_but: (obj: any, id?: string) => {
        const title = obj;

        switch (title) {
            case 'Erase_all':
                const closeAllMnemoEvent = new CustomEvent('closeAllMnemo', { detail: title });
                document.dispatchEvent(closeAllMnemoEvent);
                pinnedLeftMenu ? null : CentumVP.close_left_menu();
                break;
            case 'Overview':
                window.OpenMnemo('OV0001');
                pinnedLeftMenu ? null : CentumVP.close_left_menu();
                break;
            case 'Trend':
                window.OpenMnemo('trends');
                pinnedLeftMenu ? null : CentumVP.close_left_menu();
                break;
            default:
                alert(title);
                break;
        }
    },
    process_alarm_open: (name: string) => {
        const alarmData = { name: name };
        const EventToSend = new CustomEvent('OpenTrendOrAlarm', { detail: alarmData });
        document.dispatchEvent(EventToSend);
    },
    // trends_open: (data: { name: string, item: string }) => {
    //     const trendsData = data;
    //     const EventToSend = new CustomEvent('OpenTrendOrAlarm', { detail: trendsData });
    //     document.dispatchEvent(EventToSend);
    // },
    open_faceplate: (name: string) => {
        const event = new CustomEvent('centum_open_faceplate', { detail: { name: name } });
        document.dispatchEvent(event);
    },
    trends_find_group: (name: string) => {
        let Parameters = GetTrendsGroup(window.CentumTrendsTree[0], name);

        window.OpenMnemo(`CentumVPTrends?${Parameters}`);
    },
    SetParam: (name: string, value: any, ack?: number) => {
        let isSetParam = true;
        if (ack == 1) {
            ///acknowledgement
            let index: number = name.lastIndexOf('.');
            if (index != -1 && index != name.length) {
                let param = name.substring(index + 1);
                let block = '';
                let tag = name.substring(0, index);
                isSetParam = false;
                if (typeof value === 'string') {
                    window.OpenMnemo(
                        `Y_SET_Verification?BLOCK=${block}&TAG=${tag}&PARAM=${param}&VALUE='${value}'`,
                        'SpecialWin'
                    );
                } else {
                    window.OpenMnemo(
                        `Y_SET_Verification?BLOCK=${block}&TAG=${tag}&PARAM=${param}&VALUE=${value}`,
                        'SpecialWin'
                    );
                }
            }
        } else if (ack == 2) {
            ///confirmation
            let index: number = name.lastIndexOf('.');
            if (index != -1 && index != name.length) {
                let param = name.substring(index + 1);
                let block = '';
                let tag = name.substring(0, index);
                isSetParam = false;
                if (typeof value === 'string') {
                    window.OpenMnemo(
                        `Y_SET_Verification?BLOCK=${block}&TAG=${tag}&PARAM=${param}&VALUE='${value}'`,
                        'SpecialWin'
                    );
                } else {
                    window.OpenMnemo(
                        `Y_SET_Verification?BLOCK=${block}&TAG=${tag}&PARAM=${param}&VALUE=${value}`,
                        'SpecialWin'
                    );
                }
            }
        }

        if (isSetParam) {
            if (!SetParamGlobal(name, value)) {
                return hmiclientbase.SetParam(name, value);
            }
        }

        return 0;
    }
};

function GetTrendsGroup(obj: any, name: string) {
    let BlockGroup: string = '';

    for (let mKey in obj.blocks) {
        if (isEmpty(obj.blocks[mKey].blocks)) {
            let TagName: string = '';
            let PARAM: string = '';
            if (obj.blocks[mKey].bindinglist) {
                obj.blocks[mKey].bindinglist.map((item: any, index: number) => {
                    if (item.name == 'TAG') {
                        TagName = item.Value;
                    }
                    if (item.name == 'PARAM') {
                        PARAM = item.Value;
                    }
                });
            }
            let fullParamName = `${TagName}`;
            if (fullParamName == name) {
                let pathArray = obj.path.split('/');
                let blockIndex = pathArray.findIndex((element: any) => element.toUpperCase().includes('BLOCK'));
                let Block: any;

                if (blockIndex !== -1) {
                    Block = pathArray[blockIndex];
                }
                let Group = obj.name;

                BlockGroup = `BLOCK=${Block}&GROUP=${Group}`;

                return BlockGroup;
            }
        } else {
            const res: any = GetTrendsGroup(obj.blocks[mKey], name);
            if (res && res.length != 0) {
                return res;
            }
        }
    }
    return BlockGroup;
}

function isEmpty(obj: any) {
    for (let key in obj) {
        return false;
    }
    return true;
}

export const ContextMenuDiv = function (ev: any, item: string, typemenu: number, x: number, y: number) {
    let fieldNameElement = document.createElement('div');
    fieldNameElement.id = 'menucontext';
    fieldNameElement.className = 'centumvp_menucontext';
    fieldNameElement.style.position = 'absolute';
    fieldNameElement.style.background = '#d3cfcb';
    // fieldNameElement.style.width = "150px";
    fieldNameElement.style.zIndex = '9999';
    fieldNameElement.style.top = y.toString() + 'px';
    fieldNameElement.style.left = x.toString() + 'px';

    let IdTrend = '';

    let configarch = window.GetArchiveConfig();
    for (let paramarch in configarch) {
        if (paramarch.indexOf(item) == 0) {
            IdTrend = configarch[paramarch].SettingsGroups[0].Group;
            break;
        }
    }

    let menu =
        '<nav class="centumvp_context-menu">' +
        '<ul class="centumvp_context-menu__items">' +
        '<li class="centumvp_context-menu__item" onclick="OpenFaceplate(\'' +
        item +
        '\')">' +
        '<i class="fa fa-item">' +
        item +
        '</i>' +
        '</li>' +
        '<hr class="centumvp_context-menu__line">' +
        '<li class="centumvp_context-menu__item" onclick="OpenFaceplate(\'' +
        item +
        '\')">' +
        '<i class="fa fa-faceplate">Faceplate</i>' +
        '</li>' +
        '<li class="centumvp_context-menu__item" onclick="OpenFaceplateTun(\'' +
        item +
        '\')">' +
        '<i class="fa fa-tuning">Tuning</i>' +
        '</li>' +
        '<li class="centumvp_context-menu__item" onclick="">' +
        '<i class="fa fa-alarm">Process Alarm</i>' +
        '</li>' +
        '<li class="centumvp_context-menu__item" onclick="CentumVP.trends_find_group(\'' +
        item +
        '\')">' +
        '<i class="fa fa-trend">Trend</i>' +
        '</li>' +
        '<li class="centumvp_context-menu__item" onclick="">' +
        '<i class="fa fa-control">Control</i>' +
        '</li>' +
        '<hr class="centumvp_context-menu__line">' +
        '<li class="centumvp_context-menu__item" onclick="">' +
        '<i class="fa fa-editmenu">Edit Menu...</i>' +
        '</li>' +
        '</ul>' +
        '</nav>';

    // menu = ConvertContext(ev, typemenu, item);

    fieldNameElement.innerHTML = menu;

    document.body.appendChild(fieldNameElement);
    return true;
};
